
  import { defineComponent } from "vue"

  import { LockClosedIcon, ArrowNarrowRightIcon, CheckIcon } from "@heroicons/vue/solid"

  import WelcomeStep from "./components/Welcome.vue"
  import QuizStep from "./components/Quiz.vue"

  export default defineComponent({
    name: "BorrowerSignup",

    components: {
      WelcomeStep,
      QuizStep,
      CheckIcon
    },

    data () {
      return {
        step: 'WelcomeStep',
        formConfig: {} as any,
        nav: [
          {
            title: 'Get to know us',
            subtitle: 'Look through our site, setup an account, get started.',
            key: 'process'
          },
          {
            title: 'Build your loan request',
            subtitle: 'Help us understand your deal by sharing information with us in our intuitive loan portal',
            key: 'propertyType'
          },
          {
            title: 'Upload documentation',
            subtitle: 'Add supporting documentation to ensure we\'ve got a complete package for us to analyze',
            key: 'loanAmount'
          },
          {
            title: 'Marketplace submission',
            subtitle: 'Your assigned capital markets advisor will work closely with our algorithms to produce a picture perfect representation of your deal and shop it to the right originators from thousands of lenders across the country',
            key: 'contacts'
          },
          {
            title: 'Choose the best deal',
            subtitle: 'You\'ll work directly with your advisor or the right lender to select the best deal for you',
            key: 'approval'
          }
        ]
      }
    },

    methods: {
      handleNextStep (data) {
        if (data.showForm) this.step = 'QuizStep'
        else {
          this.formConfig = data
        }
      },

      stepCompleted (key) {
        if (this.step == 'WelcomeStep') {
          return false
        } else {
          return key == 'process'
        }
      },

      stepActive (key) {
        if (this.step == 'WelcomeStep') {
          return key == 'process'
        } else {
          return key == 'propertyType'
        }
      }
    }
  })
